import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import srm from '../assets/img/clients/srm.png';
import vit from '../assets/img/clients/vit.png';
import sathyabama from '../assets/img/clients/sathyabama.png';
import veltech from '../assets/img/clients/veltech.png';
import pes from '../assets/img/clients/pes.png';
import cmr from '../assets/img/clients/cmr.png';
import saveetha from '../assets/img/clients/saveetha.png';




const Clients = () => {
  const clients = [
    srm,
    vit,
    sathyabama,
    veltech,
    pes,
    cmr,
    saveetha,    
  ];

  return (
    <section id="clients" className="clients section">
      <div className="container section-title" data-aos="fade-up">
        <h2>India's best Institutions</h2>
        <p>We work with best clients</p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <Swiper
          modules={[Autoplay, Pagination]}
          loop={true}
          speed={600}
          autoplay={{ delay: 5000 }}
          slidesPerView="auto"
          pagination={{ clickable: true }}
          breakpoints={{
            320: { slidesPerView: 2, spaceBetween: 40 },
            480: { slidesPerView: 3, spaceBetween: 60 },
            640: { slidesPerView: 4, spaceBetween: 80 },
            992: { slidesPerView: 6, spaceBetween: 120 },
          }}
        >
          {clients.map((client, index) => (
            <SwiperSlide key={index}>
              <img src={client} className="img-fluid" alt={`Client ${index + 1}`} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Clients;
